// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"360":"bdfc9a0c75aede3e","888":"f07cb8e14d6b8592"}[chunkId] + ".css";
};